import { useState, useEffect } from 'react';

/**
 * Hook pour détecter si l'écran est mobile
 * @param {number} breakpoint - Largeur max pour considérer mobile (défaut: 768px)
 * @returns {boolean} - true si mobile
 */
export function useMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };
    
    // Vérification initiale
    checkMobile();
    
    // Écouter les changements de taille
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

/**
 * Hook pour détecter si le composant est monté (évite les erreurs SSR)
 * @returns {boolean}
 */
export function useMounted() {
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);
  
  return mounted;
}
